import Vue from "vue";
import { PERMISSION_CODES_STORAGE_KEY } from "./permissionKeys";

const STORAGE_KEY = PERMISSION_CODES_STORAGE_KEY;

/** 与后端 /api/me/permissions、登录体 permissionCodes 对齐，供 $can() 使用（响应式） */
const state = Vue.observable({
  codes: []
});

function readStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function hydratePermissionCodesFromStorage() {
  state.codes = readStorage();
}

export function setPermissionCodes(codes) {
  const list = Array.isArray(codes)
    ? [
        ...new Set(
          codes.filter((c) => c != null && String(c).trim() !== "").map((c) => String(c).trim())
        )
      ].sort()
    : [];
  state.codes = list;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

export function clearPermissionCodes() {
  state.codes = [];
  localStorage.removeItem(STORAGE_KEY);
}

export function hasPermission(code) {
  if (!code || typeof code !== "string") return false;
  const c = code.trim();
  if (!c) return false;
  return state.codes.includes(c);
}
